import { typedFetchNoImpersonate, zodValidator } from "~/api/typed-fetch";

import {
  AuthzContextResponseSchema,
  type AuthzContextResponse,
} from "../../schemas";

async function getAuthzContext(
  signal?: AbortSignal
): Promise<AuthzContextResponse> {
  return typedFetchNoImpersonate("/admin/authz/context", {
    validateResponse: zodValidator(AuthzContextResponseSchema),
    signal,
  });
}

export { getAuthzContext };
